import { AxiosHeaders } from 'axios';
import { store } from 'redux/store';
import { TStoreState } from 'redux/types';
import { getAuth } from 'redux/reducers/auth/selectors';
import { DeviceInfo, collectDeviceInfo } from 'services/deviceInfo';
import { IAxiosRequestConfig } from './types';

// ==========================================:
export const onSuccess = (config: IAxiosRequestConfig): IAxiosRequestConfig => {
	const requestConfig = config;
	const state = store.getState() as TStoreState;
	const auth = getAuth(state);
	const { refreshTime, refreshToken } = auth;
	const deviceInfo: DeviceInfo = collectDeviceInfo();

	if (auth.accessToken && auth.xMerchantId) {
		const isFormData = requestConfig.data instanceof FormData;
		const isBlob = requestConfig.data instanceof Blob;
		requestConfig.headers = AxiosHeaders.from({
			Authorization: `Bearer ${String(auth.accessToken)}`,
			'X-Merchant-Id': auth.xMerchantId,
			Accept: 'text/plain',
			// для FormData/Blob не задаём Content-Type — axios выставит multipart/form-data с boundary
			...(isFormData || isBlob ? {} : { 'Content-Type': 'application/json' }),
			...deviceInfo,
		});
	} else if (auth.accessToken) {
		const isFormData = requestConfig.data instanceof FormData;
		const isBlob = requestConfig.data instanceof Blob;
		requestConfig.headers = AxiosHeaders.from({
			Authorization: `Bearer ${String(auth.accessToken)}`,
			...(isFormData || isBlob ? {} : { 'Content-Type': 'application/json' }),
			...deviceInfo,
		});
	} else if (requestConfig.data instanceof FormData) {
		requestConfig.headers.set('Accept', 'text/plain');
		Object.entries(deviceInfo).forEach(([key, value]) => {
			requestConfig.headers.set(key, value);
		});
		requestConfig.headers.delete('Content-Type');
	} else if (requestConfig.data instanceof Blob) {
		requestConfig.headers.set(
			'Content-Type',
			requestConfig.data.type || 'application/octet-stream',
		);
	}
	if (refreshToken && refreshTime && refreshTime < Date.now()) {
		// console.log(
		// 	DateTime.now().toFormat('HH:mm:ss'),
		// 	'refreshTokenRequest!!!!',
		// 	DateTime.fromMillis(refreshTime).toISO(),
		// );
	}

	return requestConfig;
};

export const onSuccessRefresh = (config: IAxiosRequestConfig): IAxiosRequestConfig => {
	const requestConfig = config;
	const state = store.getState() as TStoreState;
	const auth = getAuth(state);

	if (auth.xMerchantId) {
		requestConfig.headers = AxiosHeaders.from({
			'X-Merchant-Id': auth.xMerchantId,
		});
	}

	return requestConfig;
};
